import { apiClient } from '@/lib/api/client'

const EASEL_BASE = '/api/v1/easel'

/**
 * Where an artist's Creative Genome stands.
 *
 * `status` is the only field a screen needs to decide what to show:
 *   none     no genome, nothing running — offer the button (if `eligible`)
 *   pending  a derivation is in flight — poll
 *   ready    they have one
 *   stalled  a job was enqueued and never landed — offer the button again
 */
export interface GenomeStatus {
  artworkCount: number
  required: number
  remaining: number
  eligible: boolean
  hasGenome: boolean
  status: 'none' | 'pending' | 'ready' | 'stalled'
  requestedAt: string | null
  updatedAt: string | null
}

export const genomeApi = {
  status: async (): Promise<GenomeStatus> => {
    const res = await apiClient.get<{ data: GenomeStatus }>(`${EASEL_BASE}/genome/status`)
    return res.data.data
  },

  /** Enqueues a derivation. Returns immediately — the work runs on the content queue. */
  generate: async (): Promise<GenomeStatus> => {
    const res = await apiClient.post<{ data: GenomeStatus }>(`${EASEL_BASE}/genome/generate`)
    return res.data.data
  },
}
